import { motion } from 'framer-motion'
import {TrendingUp, ShieldCheck, Zap} from 'lucide-react'

const STATS = [
  { icon: Zap, label: 'Instant estimates', value: '4 modes' },
  { icon: TrendingUp, label: 'Rate accuracy', value: 'Per-mile' },
  { icon: ShieldCheck, label: 'B2B networks', value: 'Verified' },
]

function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#1E293B]">
      <div className="absolute inset-0 opacity-20 [background-image:linear-gradient(to_right,#ffffff11_1px,transparent_1px),linear-gradient(to_bottom,#ffffff11_1px,transparent_1px)] [background-size:44px_44px]" />
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-[#10B981]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="max-w-3xl">
          <motion.span
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#10B981]/15 text-[#10B981] text-xs font-semibold uppercase tracking-wider border border-[#10B981]/30"
          >
            B2B Freight Intelligence
          </motion.span>

          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.05 }}
            className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] tracking-tight"
          >
            Instantly Estimate <span className="text-[#10B981]">B2B Shipping Costs</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.12 }}
            className="mt-5 text-lg sm:text-xl text-slate-300 max-w-2xl leading-relaxed"
          >
            Get accurate LTL, Full Truckload, Air, and Ocean Freight rates per mile.
            Compare transport modes and unlock firm carrier pricing in seconds.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.18 }}
            className="mt-8 flex flex-wrap gap-3"
          >
            <a
              href="#calculator"
              className="px-6 py-3 rounded-lg bg-[#10B981] hover:bg-[#0ea472] text-white font-semibold shadow-lg shadow-emerald-900/30 transition-colors"
            >
              Estimate My Freight
            </a>
            <a
              href="#services"
              className="px-6 py-3 rounded-lg bg-white/10 hover:bg-white/15 text-white font-semibold border border-white/15 transition-colors"
            >
              Explore Services
            </a>
          </motion.div>

          <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg">
            {STATS.map((s) => (
              <div key={s.label} className="rounded-xl bg-white/5 border border-white/10 p-4">
                <s.icon className="w-5 h-5 text-[#10B981]" />
                <div className="mt-2 text-white font-bold">{s.value}</div>
                <div className="text-xs text-slate-400">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
